<div class="notification-header d-flex align-items-center">
    <div class="notification-icon mr-10px" inlineSVG="assets/image/bell-filled.svg"></div>
    <div class="page-title">{{'page_titles.notifications' | translate}}</div>
</div>
